import { Box } from '@chakra-ui/react';

import { TextBold, TextRegular, TextSemiBold } from 'UiKit/typography';
import ButtonSolid from 'UiKit/button/buttonSolid';
import useGetShift from 'Domain/monitoring/useGetCurrentShift';
import { Condition } from 'Component/others';

import useMonitoringState from 'View/monitoring/state';
import PresenceModal from 'View/monitoring/component/presence-modal';
import PresenceSkeleton from 'View/monitoring/component/skeleton/presence-skeleton';

import styles from './styles.module.css';

const Presence = ({ isFetching, t }) => {
  const { updateState, selectedView } = useMonitoringState();

  const { data: shift } = useGetShift();

  const onClickPresence = async () => updateState({ selectedView: 'presence-modal' });

  return (
    <Condition statement={!isFetching} fallback={<PresenceSkeleton />}>
      <Box className={styles['presence__container']}>
        <TextBold className={styles['shift__text']}>{shift?.name}</TextBold>
        <TextRegular className={styles['time__text']}>{shift?.time}</TextRegular>
        <ButtonSolid data-testid="presence-button" className={styles['presence__button']} onClick={onClickPresence}>
          <TextSemiBold className={styles['button__text']}>{t('attendance.clock_in')}</TextSemiBold>
        </ButtonSolid>

        {/* Modal */}

        <Condition statement={selectedView === 'presence-modal'} children={<PresenceModal shift={shift} t={t} />} />
      </Box>
    </Condition>
  );
};

export default Presence;
